import styled from 'styled-components';
import {
  Flex,
} from 'web-styled';

export const Header = styled(Flex).attrs({
  flex: '0 0 50px',
  align: 'center',
  justify: 'space-between',
})`
  width: 100%;
  padding: 0 30px;
  border-bottom: 1px solid rgba(40, 45, 48, 0.1);
  background-color: #f9f9f9;
`;

export const Preview = styled(Flex).attrs({
  column: true,
  spacing: 10,
  align: 'center',
  justify: 'center',
})`
  width: 565px;
  min-height: 300px;

  .react-pdf__message,
  .react-pdf__Document {
    width: 100%;
    height: 100%;
  }
`;

export const StyledDropArea = styled(Flex).attrs({
  column: true,
  spacing: 10,
  align: 'center',
  justify: 'center',
})`
  width: 100%;
  border: 1px solid ${props => (props.isDragActive ? '#39ca74' : '#ced4da')};
  border-radius: 10px;
  outline: none;
  padding: 70px 20px;
  background-color: ${props => (props.isDragActive ? '#f9f9f9' : 'transparent')};
`;

export const Progress = styled.div`
  height: 5px;
  width: ${props => props.progress}%;
  border-radius: 5px;
  overflow: hidden;
  background-color: #39ca74;
  transition: all 0.2s linear;
`;
